module.exports = __webpack_public_path__ + "img/icon-white-63.edc8aa38.svg";